// extracted by mini-css-extract-plugin
export default {"compareValueCell":"kLEs0QiYTz1Qma_k8952","difference":"kueqrQahrSNbS8vIfcHL"};